// lightbox.svelte.ts — the one image lightbox for the whole app (SAY-1806).
// Any thumbnail (a composer attachment chip, an image on a sent message) calls
// openLightbox() with the element it is growing out of; ImageLightbox.svelte,
// mounted once in the layout, renders the enlarged view and animates from that
// element's box. A module-level rune so callers need no plumbing.
import type { Rect } from './lightbox-geometry';

export type LightboxRequest = {
	src: string;
	alt: string;
	/** Viewport box of the thumbnail the image grows out of (null → fade only). */
	from: Rect | null;
};

let current = $state<LightboxRequest | null>(null);

export function lightboxRequest(): LightboxRequest | null {
	return current;
}

export function openLightbox(src: string, alt: string, fromEl?: Element | null): void {
	const r = fromEl?.getBoundingClientRect();
	current = { src, alt, from: r ? { x: r.left, y: r.top, w: r.width, h: r.height } : null };
}

export function closeLightbox(): void {
	current = null;
}
